/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { propertySubTypeCodeSchema } from "./propertySubTypeCodeSchema.ts";
import { propertyTypeCodeSchema } from "./propertyTypeCodeSchema.ts";
import { z } from "zod";

export const searchPropertyParamsSchema = z.object({
      "status": z.string().optional(),
  "propertyType": z.lazy(() => propertyTypeCodeSchema).describe("Nature du bien — valeurs et libellés dans form-rules/property-form.json (champ propertyType)").optional(),
  "propertySubType": z.lazy(() => propertySubTypeCodeSchema).describe("Sous-nature du bien — compatibilité avec la nature et libellés dans form-rules/property-form.json (champ propertySubType)").optional(),
  "reference": z.string().optional(),
  "transactionType": z.string().optional(),
  "address": z.string().optional(),
  "price": z.object({
      "min": z.number().optional(),
  "max": z.number().optional()
      }).optional()
      })